import {
  AdminBookingUpdateProps,
  RequestProps,
  StudentForm,
  StudentModelProps,
} from "../../types";
import { useSubmitForm } from "../hooks/useSubmitForm";
import StudentFormDrawerLayout from "./StudentFormDrawerLayout";
import StudentDetailsForm from "./StudentDetailsForm";

const UpdateStudentDetails = ({
  setToggleDrawer,
  toggleDrawer,
  updatingStudent,
  request,
  updateDetailsFn,
  studentIndex,
  classes,
  classExpectation,
  refreshRequests,
}: {
  setToggleDrawer: (type: "add" | "update", triggered: boolean) => void;
  toggleDrawer: boolean;
  studentIndex: number;
  updatingStudent: StudentModelProps | undefined;
  request: RequestProps;
  updateDetailsFn: AdminBookingUpdateProps["updateStudentDetails"];
  classes: string[];
  classExpectation: string | undefined;
  refreshRequests: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [formValues, handleSubmit, updateField, formError, loading] =
    useSubmitForm(
      setToggleDrawer,
      updateDetailsFn,
      studentIndex,
      classExpectation as string,
      request.id,
      updatingStudent,
      refreshRequests
    ) as [
      StudentForm,
      () => { isInvalid: boolean } | StudentForm,
      (key: string, value: string | string[]) => void,
      string,
      boolean,
      string,
    ];

  return (
    <>
      {updatingStudent?.id && (
        <StudentFormDrawerLayout
          setToggleDrawer={setToggleDrawer}
          toggleDrawer={toggleDrawer}
          handleSubmit={handleSubmit}
          loading={loading}
        >
          <StudentDetailsForm
            classes={classes}
            formError={formError}
            formValues={formValues}
            subjects={updatingStudent.subjects}
            updateField={updateField}
          />
        </StudentFormDrawerLayout>
      )}
    </>
  );
};

export default UpdateStudentDetails;
